<template lang="pug">
.navbar.nowrap(@click.capture="activateFocus")
  .navbar-logo
    img(src="../assets/img/nplex.svg")
  .navbar-left(v-if="!registrationNavbar")
    .navbar-item
      router-link(:to="{name: 'dashboard'}") Dashboard
    .navbar-item(@click.prevent="select('search')" :class="{selected: selected('search')}" v-if="$auth.sworn()")
      a(href="/searches") Search
        icon.down-icon(name="sort-down")
      transition(name="fade")
        .navbar-dropdown-menu(v-show="selected('search')")
          router-link.navbar-dropdown-item(to="/my_searches") My Searches
          router-link.navbar-dropdown-item(:to="{name: 'person_search'}") Person Search
    .navbar-item(@click.prevent="select('reports')" :class="{selected: selected('reports')}" v-if="$auth.sworn()")
      a(href="") Reports
        icon.down-icon(name="sort-down")
      transition(name="fade")
        .navbar-dropdown-menu(v-show="selected('reports')")
          router-link.navbar-dropdown-item(:to="{name: 'my_reports'}") My Reports
          router-link.navbar-dropdown-item(:to="{name: 'store_activity_search'}") Store Activity Report
          router-link.navbar-dropdown-item(:to="{name: 'geo_activity_search'}") Geo-Activity Report
          router-link.navbar-dropdown-item(:to="{name: 'transaction_summary'}") Transaction Summary Report
          router-link.navbar-dropdown-item(:to="{name: 'transaction_lookup'}") Receipt Transaction ID Lookup
          router-link.navbar-dropdown-item(:to="{name: 'multiple_id_search'}") Multiple ID Search
          router-link.navbar-dropdown-item(:to="{name: 'store_feed_select'}") Live Store Feed
    .navbar-item(@click.prevent="select('watch')" :class="{selected: selected('watch')}" v-if="$auth.sworn()")
      a(href="") Watch
        icon.down-icon(name="sort-down")
      transition(name="fade")
        .navbar-dropdown-menu(v-show="selected('watch')")
          router-link.navbar-dropdown-item(:to="{name: 'watch_list'}") View Watches
          router-link.navbar-dropdown-item(:to="{name: 'add_watch'}") Add Person Watch
    .navbar-item(@click.prevent="select('admin')" :class="{selected: selected('admin')}" v-if="$auth.agencyAdmin()")
      a(href="") Admin
        icon.down-icon(name="sort-down")
      transition(name="fade")
        .navbar-dropdown-menu(v-show="selected('admin')")
          .navbar-dropdown-item.section Users
            router-link.navbar-dropdown-item(to="/admin/user_search") User Search
            router-link.navbar-dropdown-item(to="/admin/add_new_user") Add User
          .navbar-dropdown-item.section Usage Reports
            router-link.navbar-dropdown-item(:to="{name: 'agency_usage_search'}") Agency Level
            router-link.navbar-dropdown-item(:to="{name: 'user_usage_search'}") User Level
          .navbar-dropdown-item.section(v-show="$auth.internalAdmin()") Internal (Appriss Admin Only)
            router-link.navbar-dropdown-item(:to="{name: 'dashboard_settings'}") Dashboard Settings
    .navbar-item
      router-link(:to="{name: 'help'}") Help
  .navbar-right(v-if="!registrationNavbar")
    .navbar-item(@click.prevent="select('account')" :class="{selected: selected('account')}")
      a(href="") {{ $store.state.account.firstName }} {{ $store.state.account.lastName }}
        icon.down-icon(name="sort-down")
      transition(name="fade")
        .navbar-dropdown-menu(v-show="selected('account')")
          router-link.navbar-dropdown-item(:to="{name: 'my_account'}") My Account
          button.btn.btn-primary.log-out-button(@click="logout") Log Out
  .navbar-right(v-if="registrationNavbar")
    .navbar-item
      router-link(:to="{name: 'login'}") Login
</template>

<script>
import 'vue-awesome/icons/sort-down'
import * as session from '@/lib/session'

export default {
  name: 'Navbar',
  props: {
    focus: {
      type: Boolean,
      default: false,
    },
  },
  data: function() {
    return {
      selectedMenu: null,
    }
  },
  methods: {
    select(item) {
      if (this.selectedMenu === item) this.selectedMenu = null
      else this.selectedMenu = item
    },
    selected(item) {
      return this.selectedMenu === item && this.focus
    },
    activateFocus() {
      this.$emit('update:focus', true)
    },
    logout() {
      session.signOut()
      this.$router.push({ name: 'login' })
    },
  },
  watch: {
    focus(val) {
      if (!val) this.selectedMenu = null
    },
  },
  computed: {
    registrationNavbar() {
      return this.$route.path.includes('registration')
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../assets/styles/bodies';

$bg-color: #4e2f60;
$fg-color: white;
$bg-selected-color: #1e1432;
$height: 48px;
$anim-speed: 0.2s;

.nowrap {
  white-space: nowrap;
}

.navbar {
  background-color: $bg-color;
  color: $fg-color;
  display: flex;
  height: $height;
  padding-top: 0;
  padding-bottom: 0;

  a {
    color: $fg-color;
  }

  a:hover {
    color: $fg-color;
    text-decoration: none;
  }

  .navbar-logo {
    margin-right: 3rem;
    img {
      height: 3rem;
    }
  }

  .navbar-left {
    margin-right: auto;
    display: flex;
    height: 100%;
  }

  .navbar-right {
    margin-left: auto;
    display: flex;
    height: 100%;

    .navbar-dropdown-menu {
      right: 1rem;
    }
  }

  .navbar-item {
    font-size: 0.875rem;
    font-weight: bold;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;

    a {
      padding-left: 1.5rem;
      padding-right: 1.5rem;
    }

    .down-icon {
      margin-left: 0.4rem;
    }
  }

  .navbar-item.selected {
    background: $bg-selected-color;
    transition: background $anim-speed;
  }

  .navbar-dropdown-menu {
    position: absolute;
    top: 48px;
    background-color: $bg-selected-color;
    font-weight: normal;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    min-width: 200px;
    z-index: 100;

    .navbar-dropdown-item {
      @extend .body-1;
      display: block;
      padding-left: 1rem;
      padding-right: 1rem;
      padding-top: 0.5rem;
      padding-bottom: 0.5rem;
    }

    .navbar-dropdown-item.section {
      font-size: 0.875rem;
      font-weight: bold;

      .navbar-dropdown-item {
        @extend .body-1;
        font-weight: normal;
        padding: 0;
      }
    }
  }

  .log-out-button {
    margin: 1rem;
    width: 7rem;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity $anim-speed;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
}

@media screen and (max-width: 980px) {
  .navbar {
    flex-wrap: nowrap;
  }
}

@media screen and (max-width: 1050px) {
  .navbar-logo {
    margin-right: auto !important;
  }
}
</style>
